(() => {
  if (window.SuncoProductRails?.init) {
    window.SuncoProductRails.init();
    return;
  }

  const railSelector = [
    'main[data-template^="product"] .sunco-pdp-related-products .resource-list--grid.sunco-plp-products--grid',
    '.sunco-recently__grid.sunco-plp-products--grid',
    '.sunco-plp-recently__grid.sunco-plp-products--grid',
    '.sunco-search-recently__grid.sunco-plp-products--grid',
  ].join(',');
  const sectionSelector = '.sunco-pdp-related-products, .sunco-recently, .sunco-plp-recently, .sunco-search-recently';
  const initializedRails = new WeakSet();
  const resizeObservers = new WeakMap();

  function createButton(direction) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = `sunco-product-rail-button sunco-product-rail-button--${direction}`;
    button.dataset.suncoProductRailDirection = direction;
    button.setAttribute('aria-label', direction === 'prev' ? 'Previous products' : 'Next products');
    button.innerHTML = direction === 'prev'
      ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m15 18-6-6 6-6"></path></svg>'
      : '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 6 6 6-6 6"></path></svg>';
    return button;
  }

  function getSection(rail) {
    return rail.closest(sectionSelector) || rail.parentElement;
  }

  function ensureFrame(rail) {
    if (rail.parentElement?.classList.contains('sunco-product-rail-frame')) {
      return rail.parentElement;
    }

    const frame = document.createElement('div');
    frame.className = 'sunco-product-rail-frame';
    rail.parentElement?.insertBefore(frame, rail);
    frame.append(rail);

    return frame;
  }

  function ensureControls(frame) {
    let controls = frame.querySelector('[data-sunco-product-rail-controls]');

    if (!controls) {
      controls = document.createElement('div');
      controls.className = 'sunco-product-rail-controls';
      controls.dataset.suncoProductRailControls = 'true';
      controls.hidden = true;
      controls.append(createButton('prev'), createButton('next'));
      frame.append(controls);
    }

    return controls;
  }

  function getScrollStep(rail) {
    const firstCard = rail.querySelector(':scope > .resource-list__item, :scope > .sunco-plp-card');
    const railStyle = getComputedStyle(rail);
    const gap = parseFloat(railStyle.columnGap || railStyle.gap || '0') || 0;
    const cardWidth = firstCard?.getBoundingClientRect().width || 0;

    return Math.max(cardWidth + gap, rail.clientWidth * 0.82);
  }

  function updateControls(rail, controls) {
    const maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
    const canScroll = maxScroll > 4 && rail.children.length > 1;
    const prev = controls.querySelector('[data-sunco-product-rail-direction="prev"]');
    const next = controls.querySelector('[data-sunco-product-rail-direction="next"]');

    controls.hidden = !canScroll;
    if (!canScroll || !prev || !next) return;

    prev.disabled = rail.scrollLeft <= 2;
    next.disabled = rail.scrollLeft >= maxScroll - 2;
  }

  function setupRail(rail) {
    const section = getSection(rail);
    if (!section) return;

    section.classList.add('sunco-product-rail-section');
    rail.classList.add('sunco-product-rail');

    const frame = ensureFrame(rail);
    const controls = ensureControls(frame);
    const prev = controls.querySelector('[data-sunco-product-rail-direction="prev"]');
    const next = controls.querySelector('[data-sunco-product-rail-direction="next"]');

    if (!initializedRails.has(rail)) {
      prev?.addEventListener('click', () => {
        rail.scrollBy({ left: -getScrollStep(rail), behavior: 'smooth' });
      });
      next?.addEventListener('click', () => {
        rail.scrollBy({ left: getScrollStep(rail), behavior: 'smooth' });
      });
      rail.addEventListener('scroll', () => updateControls(rail, controls), { passive: true });
      initializedRails.add(rail);
    }

    if (!resizeObservers.has(rail) && 'ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(() => updateControls(rail, controls));
      resizeObserver.observe(rail);
      resizeObservers.set(rail, resizeObserver);
    }

    requestAnimationFrame(() => updateControls(rail, controls));
  }

  function init(root = document) {
    root.querySelectorAll(railSelector).forEach(setupRail);
  }

  function scheduleInit(root = document) {
    const run = () => init(root);

    if (root !== document) {
      run();
      return;
    }

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(run, { timeout: 1600 });
      return;
    }

    window.setTimeout(run, 900);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scheduleInit(), { once: true });
  } else {
    scheduleInit();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));

  window.SuncoProductRails = { init, scheduleInit };
})();
